import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FiForumSharedService } from '@fi-shared/fi-forum/fi-forum-shared.service';
import { IForumLightWeight, IForumPostEdit } from '@fi-shared/fi-forum/fi-forum';
import { FiForumPostEditComponent } from '@fi-shared/fi-forum/fi-forum-post-edit/fi-forum-post-edit.component';

@Component({
    selector: 'fi-forum-post-add',
    template: `
        <div class="fi-container-vertical">
            <mat-card class="fi-content-card">
                <fi-forum-post-edit
                    [forumPost]="newForumPost"
                    [(forumId)]="forumId"
                    (forumIdChange)="onForumIdChange($event)"
                    [availableForums]="availableForums"
                    [titlePlaceholderTextId]="'forum.subject'"
                    (forumPostSaved)="onNewForumPostSaved($event)"
                    (editCancelled)="onEditCancelled()"
                ></fi-forum-post-edit>
            </mat-card>
        </div>
    `,
    styleUrls: ['./fi-forum-post-add.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-forum-post-add' },
    standalone: false,
})
export class FiForumPostAddComponent implements OnInit {
    @Input() forumId: number;
    @Output() forumIdChange = new EventEmitter<number>();
    @Input() availableForums: IForumLightWeight[];
    @Output() forumPostAdded = new EventEmitter<IForumPostEdit>();
    @Output() editCancelled = new EventEmitter();

    @ViewChild(FiForumPostEditComponent, { static: true }) forumPostEditComponent: FiForumPostEditComponent;

    newForumPost: IForumPostEdit;

    constructor(private forumService: FiForumSharedService) {}

    ngOnInit() {
        this.newForumPost = this.forumService.getNewForumPostInstance(this.forumId);
    }

    onForumIdChange(newForumId: number) {
        this.forumIdChange.emit(newForumId);
    }

    onNewForumPostSaved($event: IForumPostEdit) {
        this.forumPostAdded.emit($event);
        this.newForumPost = this.forumService.getNewForumPostInstance(this.forumId);
    }

    onEditCancelled() {
        this.editCancelled.emit();
    }
}
